<template>
  <div class="wrapper">
    <FORM ref="childForm" @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable" @btnclick="bthClick" :pageData="pageData"></table-page>
    <UPDATE ref="childUpdate" @submit="submit" :updateData="updateData">
      <template v-slot:slotRemarkData="update">
        <!--语言说明-->
        <slotRemark :update="update"></slotRemark>
      </template>
    </UPDATE>
    <UPDATE ref="childUpdateExtraPrize" @submit="submitExtraPrize" :updateData="updateExtraPrizeData"></UPDATE>
  </div>
</template>

<script>

import tablePage from '@/components/page/table.vue'
import FORM from '@/components/page/form.vue'
import UPDATE from '@/components/page/update.vue'
import slotRemark from '@/views/crs/quantitytask/slotRemark.vue'
import DateUtil from '@/utils/IM/tradeDataUtil.js'
import Qs from 'qs'
import Url from '@/views/crs/util/url'

let taskTypes = { 1: '签到', 2: '推薦好友', 3: '交易', 4: '凈入金', 5: '开通真实交易账号', 6: '上传身份证', 7: '绑定银行卡', 8: '激活账号', 10: '交易盈虧' }
let statusArr = { 0: '未開啟', 1: '啟用',2:"禁用" }
let categorys = { 1: '每日任务', 2: '成长任务', 3: '限时任务', 4: '特殊任务' }
let slotRemarkData = [{ title: '', illustrate: '', language: '' }]
export default {
  name: 'list',
  components: {
    tablePage,
    FORM,
    UPDATE,
    slotRemark
  },
  methods: {
    checkbox(row) {
      this.deleteIds = row.map(key => key.id).join(',')
    },
    /*查询表单按钮点击事件*/
    formclick(clickName, data) {
      if (window.$t('common.search') == clickName || '查询' == clickName) {
        this.queryData = data
        this.$refs.childTable.defaultGetData(data)
      } else if (window.$t('common.add') == clickName || '增加' == clickName) {
        this.$refs.childUpdate.open()
      } else if (window.$t('crs.quantityTask.addtionalConfig') == clickName || '额外奖励设置' == clickName) {
        this.$axios.get(Url.quantityTask.addtionalConfig, {
          params: {
            businessTypeAlias: DateUtil.getParamKey(this.$route.params)
          }
        }).then(res => {
          if (res.code == 0) {
            if (res.result) {
              this.$refs.childUpdateExtraPrize.open(res.result)
            } else {
              this.$refs.childUpdateExtraPrize.open()
            }
          } else {
            this.$message.error(res.message)
          }
        })
      }
    },
    dataChange(url, option, suc, fail) {
      this.$axios.post(url, Qs.stringify(option || {})).then(res => {
        if (suc && (typeof suc == 'function')) suc(res)
      }).catch(res => {
        if (fail && (typeof fail == 'function')) fail(res)
      })
    },
    /*表格按钮点击事件*/
    bthClick(clickName, row) {
      if (clickName == 'update') {
        row.values = row.titleIllustrates
        row.time = [row.startTime,row.endTime]
        this.$refs.childUpdate.open(row)
      } else if (clickName == 'delete') {
        this.dataChange(Url.quantityTask.dailyDel, { id: row.id }, res => {
          if (res.code == 0) {
            this.$refs.childTable.defaultGetData(this.queryData)
            this.$message.success('suc')
          } else {
            this.$message.error(res.message)
          }
        })
      }
      else if (clickName == 'status') {
        this.dataChange(Url.quantityTask.dailyStatus, {status:row.status,id:row.id,businessTypeAlias:DateUtil.getParamKey(this.$route.params)}, res => {
          if (res.code == 0) {
            this.$refs.childTable.defaultGetData(this.queryData)
            this.$message.success('suc')
          } else {
            this.$message.error(res.message)
          }
        })
      }
    },
    /*新增或跟提交数据触发事件*/
    submit(model) {
      model.values = JSON.stringify(model.values)
      model.startTime=  model.time[0]
      model.endTime= model.time[1]
      this.dataChange(Url.quantityTask.dailyEdit, model, res => {
        if (res.code == 0) {
          this.$refs.childUpdate.close()
          this.$message.success('操作成功')
          this.$refs.childTable.defaultGetData(this.queryData)
        } else {
          this.$message.error(res.message)
        }
      })
    },
    submitExtraPrize(model) {
      this.dataChange(Url.quantityTask.addtionalEdit, model, res => {
        if (res.code == 0) {
          this.$refs.childUpdateExtraPrize.close()
          this.$message.success('操作成功')
          this.$refs.childTable.defaultGetData(this.queryData)
        } else {
          this.$message.error(res.message)
        }
      })
    }
  },
  data() {
    return {
      deleteIds: '',
      queryData: {},
      /*新增或更新*/
      updateData: {
        cols: [
          { title: 'id', field: 'id', hidden: true },
          {title: window.$t('crs.quantityTask.businessTypeAlias'),field: 'businessTypeAlias',data:DateUtil.getParamKey(this.$route.params), hidden: true},
          { title: window.$t('crs.quantityTask.name'), field: 'name',required:true },
          { title: window.$t('crs.quantityTask.startTime'), field: 'time', type: 9, data:[],required:true },

          {
            title: window.$t('crs.quantityTask.category'),
            field: 'category',
            type: 2,
            optionList: categorys,
            multiple: false,
            isNumber: true,required:true
          },
          {
            title: window.$t('crs.quantityTask.type'),
            field: 'typeId',
            type: 2,
            optionList: taskTypes,
            multiple: false,
            isNumber: true,required:true
          },
          {
            title: window.$t('crs.quantityTask.rule'),
            field: 'rule',
            textType: 'textarea',
            remarkType: true,
            required:true,
            remarkTxt: '規則樣例(格式嚴格按照下面的json格式弄):<br>' +
              '1、打卡(day：周幾)   [{"day":1,"quantity":5},{"day":2,"quantity":10}]<br>' +
              '2、推薦好友(number：推薦好友人數)   {"number":1,"quantity":5}<br>' +
              '3、交易或盈虧(不配置productType代表指定產品，不配productName代表指定類型，兩個都不配代表所有交易,如果配置是多個產品類型<"productType":"1,2,3">)   {"productType":1,"productName":"BTCUSDT","volume":0.5,"quantity":5}<br>' +
              '4、凈入金（quota：入金值）   {"quota":100.05,"quantity":5}<br>' +
              'PRD產品類型： 2->外汇、3->参考、4->商品、5->指数、6->虚拟币、7->股票'
          },
          {
            title: '条件组',
            field: 'values',
            type: 10,
            slot: 'slotRemarkData',
            required: true,
            data: slotRemarkData
          }
        ]
      },
      updateExtraPrizeData: {
        cols: [
          { title: 'id', field: 'id', hidden: true },
          {title:'businessTypeAlias',field:'businessTypeAlias',data:DateUtil.getParamKey(this.$route.params),hidden: true},
          { title: '额外奖励金额', field: 'quantity',required:true },
          {
            title: '状态',
            field: 'status',
            type: 2,
            optionList: statusArr,
            multiple: false,
            isNumber: true
          }
        ]
      },
      /*from查询表单*/
      formData: {
        hasLable: true,
        cols: [
          {
            title: 'businessTypeAlias',
            field: 'businessTypeAlias',
            data: DateUtil.getParamKey(this.$route.params),
            hidden: true
          },
          {
            title: window.$t('crs.quantityTask.category'),
            field: 'category',
            type: 2,
            optionList: categorys,
            multiple: false
          },
          {
            title: '状态',
            field: 'status',
            type: 2,
            optionList: statusArr,
            multiple: false
          },
          { click: window.$t('common.search') },
          { click: window.$t('common.add'), auth: 'crs:dailyTask:add' },
          { click: window.$t('crs.quantityTask.addtionalConfig'), auth: 'crs:addtionalConfig:add' }
        ]
      },
      /*table生成*/
      pageData: {
        queryUrl: Url.quantityTask.dailyQuery,
        selection: false,
        sequence: false,
        method: 'get',
        cols: [
          { title: 'ID', field: 'id' },
          { title: window.$t('crs.quantityTask.name'), field: 'name' },
          { title: window.$t('crs.quantityTask.title'), field: 'title' },
          { title: window.$t('crs.quantityTask.illustrate'), field: 'illustrate' },
          { title: window.$t('crs.quantityTask.rule'), field: 'rule' },
          {
            title: window.$t('crs.quantityTask.category'), field: 'category', render: (data, full) => {
              return categorys[data]
            }
          },
          {
            title: window.$t('crs.quantityTask.taskType'), field: 'typeId', render: (data, full) => {
              return taskTypes[data]
            }
          },
          {
            title: window.$t('crs.quantityTask.status'), field: 'status', render: (data, full) => {
              return statusArr[data]
            }
          },
          {
            title: window.$t('crs.quantityTask.ctime'), field: 'ctime', render: (data, full) => {
              return DateUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')
            }
          },
          {
            title: window.$t('crs.quantityTask.startTime'), field: 'startTime', render: (data, full) => {
              if (data > 0) {
                return DateUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')
              } else {
                return 'None'
              }
            }
          },
          {
            title: window.$t('crs.quantityTask.endTime'), field: 'endTime', render: (data, full) => {
              if (data > 0) {
                return DateUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')
              } else {
                return ''
              }
            }
          },
          {
            title: window.$t('crs.bt.operation'),
            btnClick: [
              {
                name: window.$t('crs.quantityTask.taskStatus'),
                click: 'status',
                type: 'primary',
                icon: 'el-icon-edit',
                auth: 'crs:dailyTask:status'
              },
              {
                name: window.$t('crs.bt.edit'),
                click: 'update',
                type: 'primary',
                icon: 'el-icon-edit',
                auth: 'crs:dailyTask:edit'
              },
              {
                name: window.$t('crs.bt.delete'),
                click: 'delete',
                type: 'primary',
                icon: 'el-icon-delete',
                auth: 'crs:dailyTask:del'
              }
              ]
          }
        ]
      }
    }
  }
}
</script>
